import React, { useEffect, useRef } from "react";
import Image1 from "../Images/Imagess/image1.jpg";
import Image2 from "../Images/Imagess/image2.jpg";
import Image3 from "../Images/Imagess/image3.jpg";
import Image4 from "../Images/Imagess/image4.jpg";
import Image5 from "../Images/Imagess/image5.jpg";
import Image6 from "../Images/Imagess/image6.jpg";
import Image7 from "../Images/Imagess/HeroImgs1.jpeg";
import Image8 from "../Images/Imagess/HeroImgs2.jpeg";
import Image9 from "../Images/Imagess/HeroImgs3.jpeg";
import { useNavigate } from "react-router-dom";
import "../CSS/Welcome1.css";

const Welcome2=()=>{

    const stackRef = useRef(null);

    useEffect(() => {
      if (!stackRef.current) return; // Ensure stackRef is available
  
      const stack = stackRef.current;
      const cards = Array.from(stack.children)
        .reverse()
        .filter((child) => child.classList.contains("About_card"));
  
      cards.forEach((card) => stack.appendChild(card));
  
      const moveCard = () => {
        const lastCard = stack.lastElementChild;
        if (lastCard.classList.contains("About_card")) {
          lastCard.classList.add("swap");
  
          setTimeout(() => {
            lastCard.classList.remove("swap");
            stack.insertBefore(lastCard, stack.firstElementChild);
          }, 1200);
        }
      };
  
      let autoplayInterval = setInterval(moveCard, 4000);
  
      const handleCardClick = (e) => {
        const card = e.target.closest(".About_card");
        if (card && card === stack.lastElementChild) {
          card.classList.add("swap");
  
          setTimeout(() => {
            card.classList.remove("swap");
            stack.insertBefore(card, stack.firstElementChild);
          }, 1200);
        }
      };
  
      stack.addEventListener("click", handleCardClick);
  
      return () => {
        clearInterval(autoplayInterval);
        stack.removeEventListener("click", handleCardClick);
      };
    }, []);
  
     const navigate = useNavigate(); // Initialize navigate function
    
        const handleExploreClick = () => {
            navigate("/about"); // Navigate to /about
        };
    
    return(
        <div className="About_Section" style={{backgroundColor:"black"}}>
        <div className="gradient-circle1" style={{backgroundColor:"black"}}></div>
        <div className="About_main">
          <div className="About_content">
            <h1 className="welcome1h1"> <span className="welcometo">Welcome to </span><span className="blackthemegradient">Janushree Ladies Parlour</span></h1>
            <div className="welcome2p">
            <div className="welcome2p1">
              
              <p className="About_p">
              We bring out the best in you with our expert beauty services. Our skilled professionals are dedicated to providing personalized treatments that leave you feeling refreshed and rejuvenated. Experience the perfect blend of relaxation and beauty at Janushree, where every visit is a step towards a more confident you. 
              </p>
              </div>
            </div>
            <button onClick={handleExploreClick} className="btn">Explore</button>
          </div>
          <div className="roundedSquare1" ></div>
          <div className="stack" ref={stackRef}>
            <div className="About_card">
              <img
                src={Image7}
                alt=""
              />
            </div>
            <div className="About_card">
              <img
                src={Image8}
                alt=""
              />
            </div>
            <div className="About_card">
              <img
                src={Image9}
                alt=""
              />
            </div>
            <div className="About_card">
              <img
                src={Image4}
                alt=""
              />
            </div>
            <div className="About_card">
              <img
                src={Image5}
                alt=""
              />
            </div>
            <div className="About_card">
              <img
                src={Image6}
                alt=""
              />
            </div>
          </div>
          
        </div>
       
      </div>
    );
}

export default Welcome2;